module.exports = __webpack_public_path__ + "img/safety_eq.1a85cb43.jpg";